import React from "react";

interface ArticleIconProps extends React.SVGProps<SVGSVGElement> {
  width?: string;
  height?: string;
  color?: string;
}

const ArticleIcon: React.FC<ArticleIconProps> = ({
  width = "17",
  height = "17",
  color = "#A41E35",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.625 2.375V14.625H2.375V2.375H14.625ZM14.625 0.625H2.375C1.4125 0.625 0.625 1.4125 0.625 2.375V14.625C0.625 15.5875 1.4125 16.375 2.375 16.375H14.625C15.5875 16.375 16.375 15.5875 16.375 14.625V2.375C16.375 1.4125 15.5875 0.625 14.625 0.625Z"
        fill={color}
      />
      <path
        d="M10.25 12.875H4.125V11.125H10.25V12.875ZM12.875 9.375H4.125V7.625H12.875V9.375ZM12.875 5.875H4.125V4.125H12.875V5.875Z"
        fill={color}
      />
    </svg>
  );
};

export default ArticleIcon;
